import {
  ActAndSFStatus,
  ICommonDocument,
  PaymentDocumentKind,
  PaymentDocumentSubject,
  SetupUpdDocumentServer,
  normalizeCommonDocument
} from 'shared/entities/documents';

import { BaseDocumentModel } from './BaseDocumentModel';
import { SetupDocumentParamsTableModel } from './SetupDocumentParamsTableModel';

export class SetupUPDDocumentModel extends BaseDocumentModel {
  readonly status: ActAndSFStatus;
  readonly xmlUrl: string | null;
  readonly oneAssError: string | null;
  readonly kind: PaymentDocumentKind.upd = PaymentDocumentKind.upd;
  readonly subject: PaymentDocumentSubject.setup = PaymentDocumentSubject.setup;
  readonly params: SetupDocumentParamsTableModel;

  constructor({
    params,
    status,
    xmlUrl,
    oneAssError,
    ...rest
  }: ICommonDocument & {
    params: SetupDocumentParamsTableModel;
    status: ActAndSFStatus;
    xmlUrl: string | null;
    oneAssError: string | null;
    cabinetId: string;
  }) {
    super(rest);
    this.params = params;
    this.status = status;
    this.xmlUrl = xmlUrl;
    this.oneAssError = oneAssError;
  }

  static fromJson(
    raw: SetupUpdDocumentServer,
    cabinetId: string
  ): SetupUPDDocumentModel {
    const normalized = normalizeCommonDocument({
      ...raw,
      url: raw.url ?? ''
    });

    return new SetupUPDDocumentModel({
      ...normalized,
      params: SetupDocumentParamsTableModel.fromJson(raw.params),
      status: raw.status,
      xmlUrl: raw.xml_url ?? null,
      oneAssError: raw.one_ass_error ?? null,
      cabinetId
    });
  }
}
